import { initializeApp, getApps, getApp } from "firebase/app";
import {
  GoogleAuthProvider,
  getAuth,
  FacebookAuthProvider,
} from "firebase/auth";

import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyB6Oqn6Va_RL5uCskHwbJgQDq8f-lgFeGg",
  authDomain: "gari-bazar-45.firebaseapp.com",
  projectId: "gari-bazar-45",
  storageBucket: "gari-bazar-45.appspot.com",
  messagingSenderId: "743238389168",
  appId: "1:743238389168:web:d4cdeaf0ee20126b7dda75",
};

// Initialize Firebase
export const app = !getApps().length ? initializeApp(firebaseConfig) : getApp();
export const googleProvider = new GoogleAuthProvider();
export const facebookProvider = new FacebookAuthProvider();
export const auth = getAuth();
export const db = getFirestore();
export const storage = getStorage();
